import { useIsNodeStaff } from "@js/apps/common/hooks/is-node-staff";
import { useFreelancerRole } from "@js/apps/freelancer/hooks/freelancer-role";

export const useShouldDisplayL1RoleTab = (): boolean => {
  const isStaff = useIsNodeStaff();
  const { role } = useFreelancerRole();

  return Boolean(!isStaff && role?.id);
};
